import { Maybe } from 'types/graphqlTypes'
import { formatRate } from 'utils/formatRate'
import { DISPLAY } from 'constants/display'
import { ONE_CENT } from '../constants'
import { TTierNumber } from '../types'
import { getTierRange } from './getTierRange'

export interface IGetTierRangeLabelProps {
  tierNumber: Maybe<TTierNumber>
  tier1Max?: number
  tier2Max?: number
  tier3Max?: number
}

/**
 * Returns the formatted range label for a specific tier
 * @example getTierRangeLabel({ tierNumber: 1, tier1Max: 1100, tier2Max: 1250, tier3Max: 1350 }) // Under $1,100
 */
export const getTierRangeLabel = ({
  tier1Max = 0,
  tier2Max = 0,
  tier3Max = 0,
  tierNumber,
}: IGetTierRangeLabelProps): string => {
  if (!tierNumber) {
    return DISPLAY.empty
  }

  const tierRange = getTierRange({ tierNumber, tier1Max, tier2Max, tier3Max })
  const { max, min } = tierRange || {}

  if (min && !max) {
    // e.g., if min is 893.60, we want to say "Above 893.59"
    return `Above ${formatRate(min ? min - ONE_CENT : min)}`
  }
  if (min && max) {
    return `${formatRate(min)} - ${formatRate(max)}`
  }
  // e.g., if max is 682.65, we want to say "Under 682.66"
  return `Under ${formatRate(max ? max + ONE_CENT : max)}`
}
